import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RedirectAfterAddingInvalidArticleComponent } from '@shared/window/open-in-new-window/redirect-after-adding-invalid-article.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SvgIconsComponent } from './svg-icons/svg-icons.component';
import { MinRowCountDirective } from './directives/min-row-count.directive';
import { ClickFilterDirective } from './directives/click-filter.directive';
import { EdgeDuplicateRemoverDirective } from './directives/edge-duplicate-remover.directive';
import { FixedHeaderDirective } from './directives/fixed-header.directive';
import { InputAutoFocusDirective } from './directives/input-auto-focus.directive';
import { DisableControlDirective } from './directives/disable-control.directive';
import { FixedFooterDirective } from './directives/fixed-footer.directive';
import { HeightDirective } from './directives/height.directive';
import { VarDirective } from './directives/var.directive';
import { CopyFromComponent } from './copy-modal/copy-from.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaxHeightDirective } from './directives/max-height.directive';
import { GlobalFooterComponent } from './global-footer/global-footer.component';
import { HeaderRightContentComponent } from '@project/components/header-right-content/header-right-content.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateShortcutPipe } from './translate-shortcut.pipe';
import { SliderComponent } from './slider/slider.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgScrollbar } from 'ngx-scrollbar';
import { ToolbarPerspectiveMenuComponent } from '@shared/toolbar/toolbar-perspective-menu/toolbar-perspective-menu.component';
import { DoubleTapDirective } from './directives/doubletap.directive';
import { ProgressRingComponent } from './progress-ring/progress-ring.component';
import { ColorDotComponent } from './color-dot/color-dot.component';
import { AlertComponent } from './alert/alert.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { ActionLogDirective } from '@user/service/logging/actionlog.directive';
import { TooltipDirective } from './tooltip/tooltip.directive';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    TabsModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    NgxSliderModule,
    NgScrollbar,
    DoubleTapDirective,
    SvgIconComponent,
    ActionLogDirective,
    TooltipDirective,
    MinRowCountDirective,
    FixedHeaderDirective,
    GlobalFooterComponent,
    RedirectAfterAddingInvalidArticleComponent,
    InputAutoFocusDirective,
  ],
  declarations: [
    ClickFilterDirective,
    EdgeDuplicateRemoverDirective,
    HeightDirective,
    MaxHeightDirective,
    VarDirective,
    FixedFooterDirective,
    DisableControlDirective,
    CopyFromComponent,
    SvgIconsComponent,
    HeaderRightContentComponent,
    TranslateShortcutPipe,
    SliderComponent,
    ToolbarPerspectiveMenuComponent,
    ProgressRingComponent,
    ColorDotComponent,
    AlertComponent,
  ],
  exports: [
    ClickFilterDirective,
    MinRowCountDirective,
    EdgeDuplicateRemoverDirective,
    FixedHeaderDirective,
    InputAutoFocusDirective,
    HeightDirective,
    MaxHeightDirective,
    VarDirective,
    FixedFooterDirective,
    DisableControlDirective,
    SvgIconsComponent,
    HeaderRightContentComponent,
    GlobalFooterComponent,
    TranslateShortcutPipe,
    SliderComponent,
    ToolbarPerspectiveMenuComponent,
    ProgressRingComponent,
    ColorDotComponent,
  ],
})
export class SharedModule {
}
